import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EditorListItem } from './shared/services/editor-items.service';

@Injectable({
  providedIn: 'root'
})
export class EmbedBotBroadcastService {
  public informationsChanged$ = new BehaviorSubject<EditorListItem | undefined>(undefined);

}
